import { render, staticRenderFns } from "./addMenuDialog.vue?vue&type=template&id=1ee0c19e&"
import script from "./addMenuDialog.vue?vue&type=script&lang=js&"
export * from "./addMenuDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports